import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
    selector: 'app-dashboard-viewer-data-zone-genetics-rating',
    templateUrl: './dashboard-viewer-data-zone-genetics-rating.component.html',
    styleUrls: ['./dashboard-viewer-data-zone-genetics-rating.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardViewerDataZoneGeneticsRatingComponent {
  @Input() rating: number;

  arr = new Array(5);
}
